import React from 'react';

const Footer = () => {
    return (
        <div className='w-full flex items-center justify-center py-6 bg-teal-950'>
            <span className='text-md text-gray-300 font-semibold'>© 2024 MayTour™. All Rights Reserved.</span>
        </div>
    );
}

export default Footer;
